import _pick from 'lodash/pick';
import { transformAvailabilityDataToAPIShape } from '../ManageServices.helpers';

const practitionerAllowedAttributes = [
  'email',
  'first_name',
  'last_name',
  'phone',
  'venues',
  'availability_recurrence',
  'time_blocks',
  'availability_overrides',
  'service_ids',
];

export const transformPractitionerData = data =>
  _pick(transformAvailabilityDataToAPIShape(data), practitionerAllowedAttributes);
